import { Autocomplete } from 'src/components/Autocomplete';
import { TextField } from 'src/components/TextField';

interface ConvertedOption {
  id: string;
  name: string;
}

interface ConvertedFilterProps {
  label: string;
  value: string | undefined;
  setValue: (newVal: string) => void;
  valueOnly?: boolean;
}

const convertedOptions: ConvertedOption[] = [
  { id: '', name: 'All' },
  { id: 'yes', name: 'Yes' },
  { id: 'no', name: 'No' },
];

export const ConvertedFilter: React.FC<ConvertedFilterProps> = ({
  label,
  value,
  setValue,
  valueOnly,
}) => {
  const selectedOption =
    convertedOptions.find((o) => o.id === value) || convertedOptions[0];

  if (valueOnly) {
    return (
      <>
        {label}: {selectedOption.name}
      </>
    );
  }

  return (
    <Autocomplete
      options={convertedOptions}
      getOptionLabel={(option) => option.name}
      value={selectedOption}
      onChange={(_, newValue) => {
        setValue(newValue?.id || '');
      }}
      renderInput={(params) => (
        <TextField {...params} label={label} placeholder="Select Status" />
      )}
    />
  );
};
